<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               :append-to-body="true"
               width="500px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="考生姓名"
                      prop="exam_student_name">
          <el-input v-model="dataForm.exam_student_name"
                    placeholder="请输入考生姓名"></el-input>
        </el-form-item>
        <el-form-item label="考生编号"
                      prop="exam_student_no">
          <el-input v-model="dataForm.exam_student_no"
                    placeholder="请输入考生编号"></el-input>
        </el-form-item>
        <el-form-item label="录取形式"
                      prop="recruit_type">
          <el-select v-model="dataForm.recruit_type"
                     placeholder="请选择"
                     clearable>
            <el-option label="一志愿"
                       value="1">
            </el-option>
            <el-option label="调剂"
                       value="2">
            </el-option>
            <el-option label="推免"
                       value="3">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一志愿院校"
                      prop="college"
                      v-if="dataForm.recruit_type==2">
          <el-select v-model="dataForm.college"
                     filterable
                     placeholder="请选择"
                     style="width: 320px">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初试总分"
                      prop="first_exam_score">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.first_exam_score">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="复试成绩"
                      prop="second_exam_score">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.second_exam_score">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="录取成绩"
                      prop="total_exam_score">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.total_exam_score">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="学习方式"
                      prop="recruit_college_enrol_type">
          <el-select v-model="dataForm.recruit_college_enrol_type"
                     placeholder="请选择"
                     clearable>
            <el-option label="全日制"
                       value="1">
            </el-option>
            <el-option label="非全日制"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取类别"
                      prop="recruit_fix_direct_type">
          <el-select v-model="dataForm.recruit_fix_direct_type"
                     placeholder="请选择"
                     clearable>
            <el-option label="非定向"
                       value="1">
            </el-option>
            <el-option label="定向"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="dataForm.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>

      <div style="display:flex; justify-content: flex-end;marginTop:30px">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  recruitPrepareCreated,
  recruitPrepareDetail,
  recruitPreparePut,
} from '@/api/admission'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '新建复试名单'
      },
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      rules: {
        exam_student_name: [
          { required: true, message: '请输入考生姓名', trigger: 'blur' },
        ],
        exam_student_no: [
          { required: true, message: '请输入考生编号', trigger: 'blur' },
        ],
        recruit_type: [
          { required: true, message: '请选择录取形式', trigger: 'change' },
        ],
        first_exam_score: [
          { required: true, message: '请输入你的分数', trigger: 'blur' },
        ],
        second_exam_score: [
          { required: true, message: '请输入你的分数', trigger: 'blur' },
        ],
        total_exam_score: [
          { required: true, message: '请输入你的分数', trigger: 'blur' },
        ],
        recruit_college_enrol_type: [
          { required: true, message: '请选择学习方式', trigger: 'change' },
        ],
        recruit_fix_direct_type: [
          { required: true, message: '请选择录取类别', trigger: 'change' },
        ],
      },
      dataForm: {
        exam_student_name: '',
        exam_student_no: '',
        exam_score_politics: '',
        exam_score_language: '',
        exam_score_business_1: '',
        exam_score_business_2: '',
        exam_score_total: '',
        remark: '',
      },
      rowDetail: {},
    }
  },

  methods: {
    handleClose() {
      this.$emit('close')
      this.dataForm = {}
      this.$refs['dataForm'].resetFields()
    },
    open() {
      if (this.title == '编辑录取名单') {
        recruitPrepareDetail({ id: this.rowId }).then((res) => {
          this.rowDetail = res
          this.$set(this.dataForm, 'exam_student_name', res.exam_student_name)
          this.$set(this.dataForm, 'exam_student_no', res.exam_student_no)
          this.$set(this.dataForm, 'recruit_type', res.recruit_type + '')
          this.$set(this.dataForm, 'first_exam_score', res.first_exam_score)
          this.$set(this.dataForm, 'second_exam_score', res.second_exam_score)
          this.$set(this.dataForm, 'total_exam_score', res.total_exam_score)
          this.$set(
            this.dataForm,
            'recruit_college_enrol_type',
            res.recruit_college_enrol_type + ''
          )
          this.$set(
            this.dataForm,
            'recruit_fix_direct_type',
            res.recruit_fix_direct_type + ''
          )
          this.$set(this.dataForm, 'remark', res.remark)
          if (res.first_college_name) {
            this.$set(this.dataForm, 'college', {
              value: res.first_college_code,
              label: res.first_college_name,
            })
          }
        })
      }
    },
    handleSubmit() {
      console.log('this.detail', this.detail)
      console.log('this.dataform', this.dataForm)

      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.title == '新建录取名单') {
            let data = {
              year: this.detail.current_search_year,
              exam_student_no: this.dataForm.exam_student_no,
              exam_student_name: this.dataForm.exam_student_name,
              recruit_college_code: this.detail.college_code,
              recruit_college_name: this.detail.college_name,
              recruit_academy_code: this.detail.academy_code,
              recruit_academy_name: this.detail.academy_name,
              recruit_major_code: this.detail.major_code,
              recruit_major_name: this.detail.major_name,
              recruit_college_enrol_type:
                this.dataForm.recruit_college_enrol_type,
              recruit_type: this.dataForm.recruit_type,
              recruit_fix_direct_type: this.dataForm.recruit_fix_direct_type,
              first_exam_score: this.dataForm.first_exam_score,
              second_exam_score: this.dataForm.second_exam_score,
              total_exam_score: this.dataForm.total_exam_score,
              remark: this.dataForm.remark,
            }
            if (this.dataForm.college) {
              data.first_college_code = this.dataForm.college.value
              data.first_college_name = this.dataForm.college.label
            }
            recruitPrepareCreated(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`操作成功`)
            })
          } else {
            console.log('this.dataform', this.dataForm.college)
            let data = {
              id: this.rowId,
              year: this.detail.current_search_year,
              exam_student_no: this.dataForm.exam_student_no,
              exam_student_name: this.dataForm.exam_student_name,
              recruit_college_code: this.detail.college_code,
              recruit_college_name: this.detail.college_name,
              recruit_academy_code: this.detail.academy_code,
              recruit_academy_name: this.detail.academy_name,
              recruit_major_code: this.detail.major_code,
              recruit_major_name: this.detail.major_name,
              recruit_college_enrol_type:
                this.dataForm.recruit_college_enrol_type,
              recruit_type: this.dataForm.recruit_type,
              recruit_fix_direct_type: this.dataForm.recruit_fix_direct_type,
              first_exam_score: this.dataForm.first_exam_score,
              second_exam_score: this.dataForm.second_exam_score,
              total_exam_score: this.dataForm.total_exam_score,
              remark: this.dataForm.remark,
            }
            if (this.dataForm.college) {
              data.first_college_code = this.dataForm.college.value
              data.first_college_name = this.dataForm.college.label
            }
            recruitPreparePut(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`修改成功`)
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 112px;
  height: 112px;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.border {
  padding: 10px;
  width: 100%;
  border: 1px dashed #d9d9d9;
}
.desc {
  margin-top: 10px;
  font-weight: normal;
  font-size: 12px;
  color: #cccccc;
}
</style>
